import * as React from 'react';
import TextItem from '../../../components/atoms/TextItem';
import { regularStyle, smallStyle } from '../../../styles/text';
import { GrayDark } from '../../../styles/colors';
import { classes, style } from 'typestyle';
const ListItemText = ({ title, description }) => (React.createElement("div", { className: 'tds-list-item-text' },
    React.createElement("div", { className: 'tds-list-item-text-title' }, typeof title === 'string' ? React.createElement(TextItem, { style: classes(regularStyle), text: title }) : title),
    description &&
        React.createElement("div", { className: classes('tds-list-item-text-description', descriptionStyle) }, (typeof description === 'string' ? (React.createElement(TextItem, { style: smallStyle, text: description })) : (description)))));
export default ListItemText;
const descriptionStyle = style({
    color: GrayDark,
    marginTop: 2,
});
//# sourceMappingURL=ListItemText.js.map